// src/components/AnswerButtons.js
import React from "react";
import "./style.css";

const SupportInfo = ({ className }) => {
  return (
    <h5 className={`text-support ${className}`}>
      <span className="bold-text title">Veja o significado dos números abaixo:</span>
      <br />
      <span className="bold-text">0</span> = A afirmação não tem nada a ver comigo
      <br />
      <span className="bold-text">1</span> = A afirmação tem pouca relação comigo
      <br />
      <span className="bold-text">2</span> = A afirmação se aplica em parte a mim
      <br />
      <span className="bold-text">3</span> = A afirmação tem tudo a ver comigo
      <br />
    </h5>
  );
};

export default SupportInfo;
